import { render, staticRenderFns } from "./JdGiftInfoCard.vue?vue&type=template&id=3170a7bf&"
import script from "./JdGiftInfoCard.vue?vue&type=script&lang=js&"
export * from "./JdGiftInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./JdGiftInfoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports